import { Grid } from '@mui/material';
import TextRender from 'components/Global/TextRender/TextRender';
import { ICardInformationBasic } from 'interfaces/requestAQuote';
import React from 'react';
import { useBasicCardStyles } from '../VehicleCard.style';

export interface IVehicleCardBasicCaption {
  cardInfo: ICardInformationBasic;
  image: string;
  imgLoaded: boolean;
  imgError: boolean;
}

export function VehicleCardBasicCaption({
  cardInfo,
  image,
  imgLoaded,
  imgError,
}: IVehicleCardBasicCaption) {
  const basicCardClasses = useBasicCardStyles();

  return (
    <Grid container className={basicCardClasses.root}>
      <Grid
        item
        xs={12}
        className={basicCardClasses.imgContainer}
        justifyContent="center"
      >
        <img
          src={image}
          alt={cardInfo.imgAlt}
          className={`${basicCardClasses.img}`}
        ></img>
        {!imgLoaded && !imgError && (
          <div className={`${basicCardClasses.spinner_container}`}>
            <div className={`${basicCardClasses.spinner}`}></div>
          </div>
        )}
      </Grid>
      <Grid item container direction="row" xs={12}>
        {cardInfo.description && (
          <Grid item container justifyContent="center" xs={12}>
            <TextRender
              className="acr-paragraph-4"
              text={cardInfo.description || ''}
            />
          </Grid>
        )}
        {cardInfo?.modelName && (
          <Grid item xs={12} style={{ margin: '0.9375rem 0 1.25rem 1.25rem' }}>
            <TextRender
              className="acr-caption-3"
              text={`${cardInfo?.modelYear} ${cardInfo?.modelName}`}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
